import { render, staticRenderFns } from "./deanInputFieldMulti.vue?vue&type=template&id=5101bb8a&scoped=true"
import script from "./deanInputFieldMulti.vue?vue&type=script&lang=ts"
export * from "./deanInputFieldMulti.vue?vue&type=script&lang=ts"
import style0 from "./deanInputFieldMulti.vue?vue&type=style&index=0&id=5101bb8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5101bb8a",
  null
  
)

export default component.exports